import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetQuiz } from "./getQuiz.request";
import { GetQuizResponse } from "./getQuiz.types";

const useGetQuiz = (
  options?: QueryOptions<GetQuizResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["content-quiz"],
    queryFn: requestGetQuiz,
    ...options
  });

  return {
    quizzes: data?.content.quizzes,
    correctAnswersNeededToPass: data?.content.correctAnswersNeededToPass,
    ...rest
  };
};

export default useGetQuiz;
